import React, { ComponentType, SVGProps } from 'react';
import styled, { css, keyframes } from 'styled-components';
// eslint-disable-next-line import/no-namespace
import * as SS from 'styled-system';
import {
  ColorProps,
  DisplayProps,
  HeightProps,
  MarginProps,
  MaxHeightProps,
  MaxWidthProps,
  OpacityProps,
  SpaceProps,
  WidthProps,
} from 'styled-system';

import { isDefined } from 'utils/functional';

import Arrow from 'arrow.svg';
import Bell from 'bell.svg';
import Bubble from 'bubble.svg';
import Building from 'building.svg';
import Calendar from 'calendar.svg';
import Checkbox from 'checkbox.svg';
import CheckmarkBlueBackground from 'checkmark-blue-bg.svg';
import CheckmarkPath from 'checkmark-path.svg';
import Checkmark from 'checkmark.svg';
import Chevron from 'chevron-down.svg';
import CircleAdd from 'circle-add.svg';
import Clipboard from 'clipboard.svg';
import Close from 'close.svg';
import Contract from 'contract.svg';
import DocumentSearch from 'document-search.svg';
import Download from 'download.svg';
import EmailOutline from 'e-mail.svg';
import Edit from 'edit.svg';
import Email from 'email.svg';
import ExternalLink from 'external-link.svg';
import Eye from 'eye.svg';
import FacebookNew from 'facebook-new.svg';
import Facebook from 'facebook.svg';
import Flag from 'flag.svg';
import Clock from 'full-time.svg';
import FullscreenCollapse from 'fullscreen-collapse.svg';
import FullscreenExpand from 'fullscreen-expand.svg';
import Gear from 'gear.svg';
import Google from 'google.svg';
import Hamburger from 'hamburger.svg';
import Heart from 'heart.svg';
import Hide from 'hide.svg';
import HomeVirtual from 'home-virtual.svg';
import Home from 'home.svg';
import ImagePath from 'image-path.svg';
import Image from 'image.svg';
import Info from 'info.svg';
import Instagram from 'instagram.svg';
import LanguageSelection from 'language-selection.svg';
import Lightbulb from 'lightbulb.svg';
import LinkPath from 'link-path.svg';
import Link from 'link.svg';
import LinkedIn from 'linkedin.svg';
import List from 'list.svg';
import Location from 'location.svg';
import Locked from 'locked.svg';
import Mail from 'mail.svg';
import Map from 'map.svg';
import Money from 'money.svg';
import MoveDots from 'move-dots.svg';
import Move from 'move.svg';
import OrgAdd from 'org-add.svg';
import OrgClick from 'org-click.svg';
import OrgPost from 'org-post.svg';
import Paperclip from 'paperclip.svg';
import Paragraph from 'paragraph.svg';
import Pencil from 'pencil.svg';
import Person from 'person.svg';
import Phone from 'phone.svg';
import Pin from 'pin.svg';
import Plane from 'plane.svg';
import PlayButton from 'play-button.svg';
import Plus from 'plus.svg';
import Preview from 'preview.svg';
import Print from 'print.svg';
import Quote from 'quote.svg';
import Refresh from 'refresh.svg';
import Repost from 'repost.svg';
import Rocket from 'rocket.svg';
import SalaryArrow from 'salary-arrow.svg';
import Search from 'search.svg';
import StarFilled from 'star-filled.svg';
import StarOutline from 'star-outline.svg';
import Hourglass from 'temporary.svg';
import Text from 'text.svg';
import ThreeDots from 'three-dots.svg';
import Trashcan from 'trashcan.svg';
import Twitter from 'twitter.svg';
import Unlocked from 'unlocked.svg';
import Upload from 'upload.svg';
import UpwardTrend from 'upwardtrend.svg';
import Virtual from 'virtual.svg';
import Youtube from 'youtube.svg';

const DIRECTIONS = {
  up: 0,
  down: 180,
  left: 90,
  right: -90,
};
type Direction = 'up' | 'down' | 'left' | 'right';

const getIconComponent = (name) => {
  switch (name) {
    case 'search':
      return Search;

    case 'hamburger':
      return Hamburger;

    case 'checkbox':
      return Checkbox;

    case 'arrow':
      return Arrow;

    case 'salary-arrow':
      return SalaryArrow;

    case 'chevron':
      return Chevron;

    case 'link':
      return Link;

    case 'locked':
      return Locked;

    case 'unlocked':
      return Unlocked;

    case 'link-path':
      return LinkPath;

    case 'person':
      return Person;

    case 'mail':
      return Mail;

    case 'phone':
      return Phone;

    case 'calendar':
      return Calendar;

    case 'money':
      return Money;

    case 'location':
      return Location;

    case 'checkmark':
      return Checkmark;

    case 'checkmark-blue-bg':
      return CheckmarkBlueBackground;

    case 'three-dots':
      return ThreeDots;

    case 'checkmark-path':
      return CheckmarkPath;

    case 'play-button':
      return PlayButton;

    case 'language-selection':
      return LanguageSelection;

    case 'pin':
      return Pin;

    case 'trashcan':
      return Trashcan;

    case 'bell':
      return Bell;

    case 'close':
      return Close;

    case 'move':
      return Move;

    case 'move-dots':
      return MoveDots;

    case 'facebook':
      return Facebook;

    case 'facebook-new':
      return FacebookNew;

    case 'twitter':
      return Twitter;

    case 'linkedin':
      return LinkedIn;

    case 'youtube':
      return Youtube;

    case 'instagram':
      return Instagram;

    case 'google':
      return Google;

    case 'upload':
      return Upload;

    case 'upwardtrend':
      return UpwardTrend;

    case 'print':
      return Print;

    case 'heart':
      return Heart;

    case 'refresh':
      return Refresh;

    case 'text':
      return Text;

    case 'paragraph':
      return Paragraph;

    case 'quote':
      return Quote;

    case 'circle-add':
      return CircleAdd;

    case 'building':
      return Building;

    case 'org-add':
      return OrgAdd;

    case 'org-click':
      return OrgClick;

    case 'org-post':
      return OrgPost;

    case 'external-link':
      return ExternalLink;

    case 'image-path':
      return ImagePath;

    case 'fullscreen-expand':
      return FullscreenExpand;

    case 'fullscreen-collapse':
      return FullscreenCollapse;

    case 'map':
      return Map;

    case 'info':
      return Info;

    case 'preview':
      return Preview;

    case 'edit':
      return Edit;

    case 'rocket':
      return Rocket;

    case 'plus':
      return Plus;

    case 'email':
      return Email;

    case 'email-outline':
      return EmailOutline;

    case 'download':
      return Download;

    case 'hide':
      return Hide;

    case 'repost':
      return Repost;

    case 'paperclip':
      return Paperclip;

    case 'clipboard':
      return Clipboard;

    case 'list':
      return List;

    case 'clock':
      return Clock;

    case 'contract':
      return Contract;

    case 'hourglass':
      return Hourglass;

    case 'virtual':
      return Virtual;

    case 'home':
      return Home;

    case 'home-virtual':
      return HomeVirtual;

    case 'bubble':
      return Bubble;

    case 'flag':
      return Flag;

    case 'document-search':
      return DocumentSearch;

    case 'gear':
      return Gear;

    case 'lightbulb':
      return Lightbulb;

    case 'pencil':
      return Pencil;

    case 'plane':
      return Plane;

    case 'star-filled':
      return StarFilled;

    case 'star-outline':
      return StarOutline;

    case 'eye':
      return Eye;

    case 'image':
    default:
      return Image;
  }
};

const Icon = styled(
  ({
    name,
    width,
    maxWidth,
    height,
    maxHeight,
    className,
    direction,
    verticalAlign,
    display,
    component,
    fill,
    stroke,
    strokeWidth,
    opacity,
    ...props
  }: ColorProps &
    WidthProps &
    MaxWidthProps &
    HeightProps &
    MaxHeightProps &
    SpaceProps &
    DisplayProps &
    OpacityProps & {
      name?: string;
      className?: string;
      direction?: Direction;
      verticalAlign?: string;
      component?: ComponentType<{
        className?: string;
      }>;
      fill?: string;
      stroke?: string;
      strokeWidth?: string | number;
    }) => {
    const IconComponent = component || getIconComponent(name);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <IconComponent className={className} {...props} />;
  }
)`
  && {
    ${(props) => css`
      * {
        ${props.fill &&
        `
          fill: ${props.fill};
        `}
        ${props.stroke &&
        `
          stroke: ${props.stroke};
        `}
        ${props.strokeWidth &&
        `
          stroke-width: ${props.strokeWidth};
        `}
      }
      ${props.direction &&
      `
        transform: rotate(${DIRECTIONS[props.direction]}deg);
      `}
      ${props.verticalAlign &&
      `
        vertical-align: ${props.verticalAlign};
      `}
    `}
  }
  ${SS.space} ${SS.display} ${SS.opacity} ${SS.width} ${SS.height} ${SS.maxWidth} ${SS.maxHeight}
`;
const aCheck = keyframes`
  0% {
    stroke-dashoffset: 20;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;
export const AnimatedCheckmark = styled(
  ({
    width = 12,
    height = 12,
    delay,
    ...props
  }: WidthProps &
    HeightProps & {
      delay?: number;
      $duration?: number;
    }) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Icon name="checkmark-path" width={width} height={height} {...props} />
  )
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
)<SVGProps<any> & MarginProps>`
  path,
  polyline {
    fill: none;
    stroke-dasharray: 20;
    stroke-dashoffset: 20;
    animation: ${aCheck}
      ${(props) => (isDefined(props.$duration) ? props.$duration : 0.625)}s
      ${(props) => (isDefined(props.delay) ? props.delay : 0.35)}s forwards;
  }
`;
// eslint-disable-next-line import/no-default-export
export default Icon;
